import {
    commitMutation,
    graphql
} from 'react-relay'
import environment from '../../Environment'


const mutation = graphql`
    mutation DeleteContactMutation($id: String!) {
        deleteContact(id:$id) {
            id
      }
    }
  `

export default (id, callback) => {
    const variables = {
        id
    }

    commitMutation(
        environment,
        {
            mutation,
            variables,
            onCompleted: (response) => {
                callback({ status: 'OK', pyload: response.deleteContact })
            },
            onError: err => callback({ status: 'KO', message: err })
        },
    )
}